<template>
    <div class="d-flex back align-items-stretch">
        <div class="col-2 flex-column justify-content-center d-none d-lg-flex">
            <!-- <a href="http://fb.com" target="_blank">
                <img src="@/assets/whatsapp.svg" />
            </a> -->
            <!-- <a href="http://fb.com" target="_blank">
                <img src="@/assets/telegram.svg" />
            </a> -->
            <a href="https://www.linkedin.com/company/ib-academy-az/" target="_blank">
                <img src="@/assets/linkedin.svg" />
            </a>
            <a href="https://www.facebook.com/ib.academy.aze" target="_blank">
                <img src="@/assets/facebook.svg" />
            </a>
            <a href="https://www.instagram.com/ib.academy.az/" target="_blank">
                <img src="@/assets/instagram.svg" />
            </a>
            <a href="https://www.tiktok.com/@ib.academy.az" target="_blank">
                <img src="@/assets/tiktok.svg" />
            </a>
            <a href="https://www.threads.net/@ib.academy.az" target="_blank">
                <img src="@/assets/threads.svg" />
            </a>
        </div>
        <!-- <div v-else></div> -->
        <div class="col-10 flex-column justify-content-center align-items-start d-none d-lg-flex">
            <h3 align="left" v-html="$t('become_a_student')" />
            <br />
            <button class="outlined-button" onclick="Tawk_API.toggle()">
                <p>{{ $t('apply') }}</p>
            </button>

        </div>
        <div class="flex-column mob justify-content-end align-items-center d-flex d-lg-none mx-auto py-5">
            <h3 align="center" v-html="$t('become_a_student')" />
            <br />
            <button class="outlined-button" onclick="Tawk_API.toggle()">
                <p>{{ $t('apply') }}</p>
            </button>

        </div>
    </div>
</template>
<script>
export default {

}
    // background-position: bottom center;
    // background-size: auto 100%;
</script>
<style lang="css" scoped>
.back {
    position: relative;
    min-height: 100vh;
    background-image:
        linear-gradient(to bottom right, rgba(168, 70, 255, 0.52), rgba(0, 161, 154, 0.73)), url(../assets/students.png);
    background-repeat: no-repeat;
    background-size: cover;

    background-position: center;
}

.back a {
    margin: 20px;
}

.btn {
    margin: 0 !important;
    padding: 0 !important;
}

.back h3 {
    color: #fff;
    font-weight: 600;
    font-size: 5rem;
}

.mob h3 {

    font-size: 2rem !important;
}

.outlined-button {
    background-color: #66c40388;
    border-style: solid;
    border-color: white;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: white;
}

.outlined-button:hover {
    background-color: #66c403;
}

.outlined-button p {
    margin: 0;
}
</style>